var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.shouldShowButton)?_c('NiceButton',{staticClass:"code-box-button",attrs:{"loading":_vm.loading},on:{"click":_vm.sendToCodeBox}},[_vm._v(" Send To CodeBox ")]):_vm._e(),_c('CodeBoxDialog',{attrs:{"open":_vm.dialogOpen},on:{"update:dialog":_vm.updateDialogOpen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }